export const iconFontAwesomeHalloweenBroom = (
	<i className="fa-solid fa-broom"></i>
);
